import { render, staticRenderFns } from "./roster-setup.vue?vue&type=template&id=11bfb10f&scoped=true&"
import script from "./roster-setup.ts?vue&type=script&lang=ts&"
export * from "./roster-setup.ts?vue&type=script&lang=ts&"
import style0 from "./roster-setup.scss?vue&type=style&index=0&id=11bfb10f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bfb10f",
  null
  
)

export default component.exports